import React, { Fragment, useState, useContext, useEffect } from "react";
import FBannerSpend from "../../components/FspendComponents/FBannerSpend/FBannerSpend";
import { AuthContext } from "../../context/AuthContext";
import { getTopUps } from "../../api/spend";
import { useNavigate } from "react-router";
import FBoxContainer from "../../components/FBoxContainer/FBoxContainer";

// import FBannerSpend from "../../components/FBannerSpend/FBannerSpend";
// import FCategoryContainer from "../../components/FCategoryContainer/FCategoryContainer";

const RechargeScreen = ({ param }) => {
  const { setLoading,checkToken } = useContext(AuthContext);
  const [topUps, setTopUps] = useState([]);
  const route = useNavigate();

  const getTopUp = async () => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getTopUps();
      setLoading(false);
      setTopUps(data.data);
    } catch (e) {
      setLoading(false);
      //console.log(e.response?._response);
    }
  };

  useEffect(() => {
    getTopUp();
  }, []);

  const action = (item) => {
    route("/RechargeOptionScreen", {
      state: {
        id: item.id,
        iconUrl: item.iconUrl,
        name: item.displayName,
      },
    });
  };

  return (
    <>
      <FBannerSpend
        imageUrl={require("../../components/assets/images/recharge.png")}
        title="Recargas prepago"
        description="Saldo Disponible"
      />
      <div className="mb-16">
        <FBoxContainer sortedCategories={topUps} action={action} />
      </div>
    </>
  );
};

export default RechargeScreen;
